module.exports = __webpack_public_path__ + "static/tarrasque-mtg_clb-5d8260b3cdb270e9157b087c742fcb49.jpg";